import { PERMISSIONS } from '@/libs/acl/permissions'

export default [
  {
    path: '/apps/company/company-management',
    name: 'company-management',
    component: () => import('@/views/apps/company/company-list/CompanyList.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_CLIENTS,
      action: 'read',
      pageTitle: 'Client List',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Management',
        },
        {
          text: 'Company List',
          active: true,
        },
      ],
    },
  },
  // Plans
  {
    path: '/apps/plan/management',
    name: 'route-plans-plan-management',
    component: () => import('@/views/apps/plan-management/plans/PlanManagement.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_SERVICE_CHARGE_PLANS,
      action: 'read',
      pageTitle: 'Plan Management',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Service Charge Plans',
          to: '/apps/plan/management/customer',
        },
        {
          text: 'Plan Management',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/plan/types',
    name: 'route-plans-plan-types',
    component: () => import('@/views/apps/plan-management/plans/PlanTypeManagement.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_SERVICE_CHARGE_PLANS,
      action: 'read',
      pageTitle: 'Plan Types',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Plans',
          to: '/apps/plan/management',
        },
        {
          text: 'Plan Types',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/plan/management/customer',
    name: 'route-plans-customer-plans',
    component: () => import('@/views/apps/plan-management/customer-plan-management/CustomerPlanManagement.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_SERVICE_CHARGE_PLANS,
      action: 'read',
      pageTitle: 'Service Charge Plans',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Management',
        },
        {
          text: 'Service Charge Plans',
          active: true,
        },
      ],
    },
  },

  // User Info
  {
    path: '/apps/management/account-manager/users-list',
    name: 'users-list',
    component: () => import('@/views/apps/account-manager/users-list/UsersList.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_CLIENTS,
      action: 'read',
      pageTitle: 'User List',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Management',
        },
        {
          text: 'Clients',
          to: '/apps/company/company-management',
        },
        {
          text: 'User List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/management/task-management',
    name: 'route-task-management',
    component: () => import('@/views/apps/task-management/TaskManagement.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_TASKS,
      action: 'read',
      pageTitle: 'Task Management',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Management',
        },
        {
          text: 'Tasks',
        },
        {
          text: 'Task Management',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/management/task-calendar',
    name: 'route-task-calendar',
    component: () => import('@/views/apps/task-management/TaskCalendar.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_TASKS,
      action: 'read',
      pageTitle: 'Task Calendar',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Management',
        },
        {
          text: 'Tasks',
        },
        {
          text: 'Task Calendar',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/management/tickets',
    name: 'route-tickets',
    component: () => import('@/views/apps/tickets/TicketGrid.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_TICKETS,
      action: 'read',
      pageTitle: 'Tickets',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Management',
        },
        {
          text: 'Tickets',
          active: true,
        },
      ],
    },
  },
  // {
  //   path: '/apps/product/category',
  //   name: 'route-products-category',
  //   component: () => import('@/views/apps/product/category/ProductCategory.vue'),
  //   meta: {
  //     resource: 'resource_product_products',
  //     action: 'read',
  //     pageTitle: 'Product Category',
  //     breadcrumb: [
  //       {
  //         text: 'Home',
  //         to: '/dashboard',
  //       },
  //       {
  //         text: 'Product',
  //       },
  //       {
  //         text: 'Product Category',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/apps/management/account-manager/user-detail/:id',
  //   name: 'user-detail',
  //   component: () => import('@/views/apps/account-manager/users-view/UsersView.vue'),
  //   meta: {
  //     resource: 'resource_management_user_info',
  //     action: 'read',
  //   },
  // },
  // {
  //   path: '/apps/management/account-manager/user-info',
  //   name: 'user-info',
  //   component: () => import('@/views/apps/account-manager/UserInfoList.vue'),
  //   meta: {
  //     resource: 'resource_management_user_info',
  //     action: 'read',
  //     pageTitle: 'User List',
  //     breadcrumb: [
  //       {
  //         text: 'Home',
  //         to: '/dashboard',
  //       },
  //       {
  //         text: 'Ship',
  //       },
  //       {
  //         text: 'Uploaded Batches',
  //         to: '/uploaded-batches',
  //       },
  //       {
  //         text: 'Items',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/apps/management/mail-management/mail-topic',
  //   name: 'route-mail-topic',
  //   component: () => import('@/views/apps/mail-management/mail-topic/MailTopicList.vue'),
  //   meta: {
  //     resource: 'resource_mail_topic',
  //     action: 'read',
  //     pageTitle: 'Email Topic',
  //     breadcrumb: [
  //       {
  //         text: 'Home',
  //         to: '/dashboard',
  //       },
  //       {
  //         text: 'Management',
  //       },
  //       {
  //         text: 'Email Managements',
  //       },
  //       {
  //         text: 'Email Topic',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/apps/management/mail-management/mail-log',
  //   name: 'route-mail-management-mail-log',
  //   component: () => import('@/views/apps/mail-management/mail-log/MailLogList.vue'),
  //   meta: {
  //     resource: 'resource_mail_management_mail_log',
  //     action: 'read',
  //     pageTitle: 'Email Log',
  //     breadcrumb: [
  //       {
  //         text: 'Home',
  //         to: '/dashboard',
  //       },
  //       {
  //         text: 'Management',
  //       },
  //       {
  //         text: 'Email Managements',
  //       },
  //       {
  //         text: 'Email Log',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/apps/management/mail-management/mail-tenant',
  //   name: 'route-mail-management-mail-tenant',
  //   component: () => import('@/views/apps/mail-management/mail-tenant/MailTenantList.vue'),
  //   meta: {
  //     resource: 'resource_mail_management_mail_tenant',
  //     action: 'read',
  //     pageTitle: 'Email Tenant',
  //     breadcrumb: [
  //       {
  //         text: 'Home',
  //         to: '/dashboard',
  //       },
  //       {
  //         text: 'Management',
  //       },
  //       {
  //         text: 'Email Managements',
  //       },
  //       {
  //         text: 'Email Tenant',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/apps/management/mail-management/mail-topic-company',
  //   name: 'route-mail-management-mail-topic-company',
  //   component: () => import('@/views/apps/mail-management/mail-topic-company/MailTopicCompany.vue'),
  //   meta: {
  //     resource: 'resource_mail_management_mail_topic_company',
  //     action: 'read',
  //     pageTitle: 'Email Subscription',
  //     breadcrumb: [
  //       {
  //         text: 'Home',
  //         to: '/dashboard',
  //       },
  //       {
  //         text: 'Management',
  //       },
  //       {
  //         text: 'Email Managements',
  //       },
  //       {
  //         text: 'Email Subscription',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
]
